// doctor-frontend/src/pages/chc/NursingDashboard.jsx
// Workbench for nursing officers in the CHC flow. Enables the nurse to
// administer injections or procedures ordered by the Medical Officer,
// document administration, and record any adverse events or patient
// counselling.

import React from 'react';
import { Box, Typography } from '@mui/material';

export default function NursingDashboard() {
  return (
    <Box p={2} className="min-h-screen">
      <Typography variant="h6" gutterBottom>
        Nursing Services
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        View medication orders requiring nursing administration (e.g. IM/IV
        injections), record administration details, and note any patient
        counselling or adverse reactions.
      </Typography>
      {/* Future enhancements: list of pending injections, forms to capture
          administration details, follow‑up tasks. */}
    </Box>
  );
}